// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"subscribe_wrapper__2prfO","feedback":"subscribe_feedback__3DZ_n","error":"subscribe_error__1Ds7V","form":"subscribe_form__1YvSp","links":"subscribe_links__15nLn"};